export default {
  changePhoneNum: '修改手机号码',
  changeEmailAdd: '修改邮箱',
  byPhone: '手机验证',
  byEmail: '邮箱验证',
  phoneNum: '手机号码',
  email: '邮箱',
  address: '地址',
  password: '密码',
  language: '语言',
  reset: '修改密码',
  editPassword: '修改密码',
  replace: '更换',
  change: '更换',
  p1: '如果您需要添加银行账户，请拨打客户服务电话',
  resetTradeAccount: '重置交易账户密码',
  resetPassword: '重置',
  mt5label: '杠杆式外汇账户',
  PMlabel: '黄金交易账户',
  stocksecuritiesCashlabel: '证券(现金)账户',
  stocksecuritiesMarginlabel: '证券(保证金)账户',
  futuresMarginlabel: '期货账户',
  futuresDayTradingMarginlabel: '期货日内交易账户',
  changePhoneNotice: '该功能仅提供给内地客户使用',
  changeMt5Pwd: '修改外汇账户密码',
  pwdTip: '新密码必须是大小写字母、数字及其组合，长度6-15位',
  masterPwd: '修改主密码',
  pleaseEnterMaterPwd: '请输入主密码',
  readOnlyPwd: '修改只读密码',
  forgetPwd: '忘记密码',
  modifyPwdSuccss: '密码修改成功',
  modifyPwdSuccssTip: '您已成功更改密码，请使用新密码登录。',
  resetPwd: '重置密码',
  resetPwdTip: '您正在重置外汇交易密码！点击确定按钮5分钟后我们将发送密码至您的登记邮箱<{email}>，确定重置？',
  commitSuccess: '提交成功',
  commitSuccessTip: '请前往您的登记邮箱<{email}>查看密码',
  '404': '未找到',
  '405': '密碼不匹配',
  '406': '用户不存在',
  '407': '参数不匹配',
  '408': '新密码和确认密码不匹配',
  '409': '旧密码和原密码不匹配',
  '410': '参数丢失 ',
  '411': '参数密钥不允许',
  '412': '密码长度不是6-12',
  '7000': '原密码错误',
  '7001': '修改密码失败',
  '5003': '修改密码发送邮件失败',
  '10000': '修改交易账户失败',
  '90000': '账号未授权,请联系管理员',
  '90001': '登录账号或密码不正确',
  '90002': '登录账号或密码不正确',
  '90003': '登录账号或密码不正确',
  '90004': '新密码不符合规格',
  '90005': '登录账号或密码不正确',
  '90006': '登录账号或密码不正确',
  '90007': '修改密码没有返回结果',
  '90008': '登录账号或密码不正确',
  '90009': '登录账号或密码不正确',
  '90010': '频繁操作,请稍后再试',
  '90011': '密码已被使用',
  '10002': '登录账号或密码不正确',
  '10004': '账号未授权,请联系管理员',
  '10008': '登录账号或密码不正确',
  '-986': '频繁操作,请稍后再试',
  '-989': '修改密码异常，请稍后再试',
  '12001': '登录账号或密码不正确',
  '12003': '新密码不符合规格',
  '12002': '密码已被使用',
  '10013': '密码错误，用户冻结,请联系管理员',
  '10012': '用户已被冻结,请联系管理员',
  '5008': '手机号码格式不对,获取验证码失败',
  '40000': '获取验证码失败，请联系客服',
  setPassword: {
    '4001': '用户不存在',
    '4014': '用户来源错误',
    '4006': '密码长度在6-16位之间',
    '4010': '参数缺失',
    '4008': '新密码和确认密码不一致',
    '4009': '输入旧密码和用户原密码不匹配',
    title: '更换个人中心密码',
    oldPassword: '输入你的旧密码',
    newPassword: '输入你的新密码',
    confirmPassword: '再次输入你的新密码',
    submit: '提交',
    cancel: '取消',
    checkPassword: '密码必须由6-16位数字和字母组成',
    checkTradePassword: '密码格式不正确',
    checkPassWrongLen: '密码长度为6-15位',
    passwordInconsistent: '两次输入的密码不一致',
    fail: '修改密码失败',
    resetPhoneFail: '修改电话号码失败',
    notMatch: '旧密码输入错误,请重新输入'
  },
  confirm: {
    title: '成功',
    p1: '您已成功更改了密码',
    p2: '请用新密码登录',
    back: '回到登入'
  },
  changePhone: {
    title: '修改手机号码',
    phoneTitle: '当前手机号',
    subtitle: `您正在更改认证手机！更换后您可以通过新的手机登录和找回密码`,
    codeInput: '请输入有效的验证码',
    phoneInput: '请输入手机号码',
    phoneErr: '请输入正确的电话号码',
    areaErr: '请选择区号',
    success: '修改电话号码成功',
    expired: '验证码已过期',
    '413': '手机号已注册',
    '4003': '手机号已注册',
    '4001': '用户信息有误',
    registered: '手机号已被绑定',
    verCodeFail: '验证码错误,请重新输入!',
    phoneNumPlaceholder: '手机号码',
    verCodePlaceholder: '请输入',
    sendVerTip: '获取验证码',
    resetPhoneFail: '修改电话号码失败',
    samePhone: '该手机号与当前绑定手机号相同',
    sendSuccess: '验证码已发送至您的手机'
  },
  changePasswordMt5: {
    '30000': '请填写密码',
    '30001': '密码复杂度不够，请重新设置',
    '30002': '请输入6-15位由大小写字母和数字组成的密码',
    messageVerify: '短信验证',
    emailVerify: '邮箱验证',
    inputNewPassword: '请输入新密码',
    inputNewPasswordAgain: '请再次输入新密码',
    title: '输入新密码',
    checkPassword: '请输入6-15位由大小写字母和数字组成的密码'
  },
  changeEmail: {
    '413': '邮箱已注册',
    '4003': '邮箱已注册',
    '11013': '修改电话号码失败，请联系客服',
    emailEmpty: '邮箱不能为空',
    emailErr: '请输入正确的邮箱',
    emailSame: '该邮箱与当前绑定邮箱相同',
    success: '修改邮箱成功',
    changeEmailFail: '修改邮箱失败'
  },
  editAccountPassword: {
    securitiesMarginTitle: '修改证券(保证金)账户密码',
    securitiesCashTitle: '修改证券(现金)账户密码',
    futuresMarginTitle: '修改期货账户密码',
    futuresDayTradingMarginTitle: '修改期货日内交易账户密码'
  }
}
